import * as React from "react";
import { connect } from "react-redux";
import { RootState } from "~/state";
import { RouteComponentProps } from "react-router";
import { Dialog, DialogType } from "office-ui-fabric-react";
import styled from "styled-components";
import {  uploadLink } from "~/state/media/action";
import CustomTextInput from "../baseComponent/CustomTextInput";

export interface ReactFilesComponent extends React.Component<any, any>
{
    removeFiles: () => void;
}

export interface Props extends RouteComponentProps<{ parentId: string}>
{
    disabled: boolean;
}

type StateProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

const mapStateToProps = (state: RootState, ownProps: Props) => ({
    
});

const mapDispatchToProps = (dispatch: any, ownProps: Props) => ({
    uploadLink: (url: string, parentId: string) => dispatch(uploadLink(url, parentId))
});

const UploadField = styled.div`
    .files-dropzone{
        width: 291px;
        height: 100px;
        border: 1px dashed black;
    }
    h2{
        text-align: center;
        font-size: 15px;
        margin-top: 32px;
    }`;

class UploadYoutube extends React.Component<Props & StateProps>
{
    state = 
    {
        isEditing: true
    };

    onClose = () =>
    {
        const parentId = this.props.match.params.parentId || "";
        this.props.history.push(`/media/${parentId}`);
    }

    onValueChange = (value: string) =>
    {
        const parentId = this.props.match.params.parentId || "";
        this.props.uploadLink(value, parentId);
        this.props.history.push(`/media/${parentId}`);
    }

    render()
    {
        return <Dialog onDismiss={this.onClose} hidden={false} 
            dialogContentProps={{
                type: DialogType.normal,
                title: "Insert Youtube URL",
            }}
            minWidth={350}
            >
            <UploadField>
            <CustomTextInput 
                value=""
                isEditing={this.state.isEditing} 
                onChange={this.onValueChange}
                onClick={this.onClose} 
                onDismiss={this.onClose}/>
            </UploadField>
        </Dialog>;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(UploadYoutube);


// WEBPACK FOOTER //
// ./src/components/media/UploadYoutube.tsx